import React, {Component} from 'react';
import {Link, Route, Switch} from "react-router-dom";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import appRoutes from "../../../appRoutes";
import AnkieteoCmsTable from "./components/AnkieteoCmsTable";
import AnkieteoCmsForm from "./components/AnkieteoCmsForm";
import AnkieteoCmsNav from "./components/AnkieteoCmsNav";

class AnkieteoCms extends Component {
  render() {
    return <Row className="animated fadeIn">
      <Col>
        <Card>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="float-left mr-4">Ankieteo CMS</h2>

              <div>
                <Link to={appRoutes.admin.cms.ankieteo.navEdit(1)}>Edytuj górną nawigacje</Link>
                <Link className="ml-3" to={appRoutes.admin.cms.ankieteo.navEdit(2)}>Edytuj dolną nawigacje</Link>
              </div>
            </div>
          </CardHeader>
          <hr className="my-0" />
          <CardBody>
            <Row>
              <Col>
                <Switch>
                  <Route path={appRoutes.admin.cms.ankieteo.navEdit()} children={<AnkieteoCmsNav />} />
                  <Route path={appRoutes.admin.cms.ankieteo.list} children={<AnkieteoCmsTable />} />
                  <Route path={appRoutes.admin.cms.ankieteo.add} children={<AnkieteoCmsForm />} />
                  <Route path={appRoutes.admin.cms.ankieteo.edit()} children={<AnkieteoCmsForm />} />
                </Switch>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>;
  }
}

AnkieteoCms.propTypes = {};

export default AnkieteoCms;